export const BACKEND_TRANSLATION_KEYS = [
  'user_already_exists',
  'invalid_username_or_password',
]
